"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoadBalancer = void 0;
const getLoadBalancer = ({ httpClient, }) => ({ load_balancer_id, }) => {
    const path = '/load_balancers';
    const url = `${path}/${load_balancer_id}`;
    return httpClient.get(url);
};
exports.getLoadBalancer = getLoadBalancer;
//# sourceMappingURL=get-load-balancer.js.map